<template>
  <div class="expected-impact-level">
    <table>
      <thead>
        <tr>
          <th colspan="2">
            Expected Impact Level
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="SummaryLabel !== 'Flood Hazard'">
          <td><b>Generated Score:</b></td>
          <td>
            <div v-if="dataValue.score.generated" class="blue-text text-accent-4">
              {{ dataValue.score.generated }}
            </div>
          </td>
        </tr>
        <tr>
          <td>

            <b>Selected Score</b>
            <!--      {{ dataValue.score }} -->
          </td>
          <td>
            <div v-if="dataValue.score.selected" class="blue-text text-accent-4">
              {{ dataValue.score.selected }}
            </div>
          </td>
        </tr>

      </tbody>
    </table>
    <div style="height:32px; width:100%;"></div>
    <!--  -->
    <table>
      <thead>
        <tr>
          <th>
            Justification
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div v-html="dataValue.score.justification"></div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="height:32px; width:100%;"></div>
    <!--  -->
    <table class="hide" style="display:none;">
      <thead>
        <tr>
          <th>
            {{ SummaryLabel }} Risk Assessment Summary
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in assessmentSchema" :key="key">
          <td>

            <div class="col s12 no-padding"><b>{{ item.label }}: </b></div>
            <div class="col s12 no-padding" v-if="key === 'impact_level'"> {{ dataValue.score.selected }}</div>
            <div class="col s12 no-padding" v-else-if="key === 'priority'">
              {{ $_format(dataValue.assessment.priority_rating) }}
            </div>

            <div class="col s12 no-padding" v-else-if="key === 'key_vun'">
              <div v-if="dataValue.assessment.key_vuln">
                {{ dataValue.assessment.key_vuln.toString() }}
              </div>
              <div v-if="dataValue.assessment.other_vuln &&
                dataValue.assessment.key_vuln === 'Other (specify)'" v-html="dataValue.assessment.other_vuln"></div>
            </div>
            <div class="col s12 no-padding" v-else-if="key === 'proposed'" v-html="dataValue.assessment.content"></div>

          </td>
        </tr>
      </tbody>
    </table>
    <div style="height:32px; width:100%;"></div>


  </div>
</template>
<script>
import assessmentSchema from "@/JsonSchemas/assessmentSummary";
export default {
  name: "SummaryAssessment",
  props: {
    SummaryLabel: {
      type: String,
    },
    dataValue: {
      type: [Object],
    },
  },
  data: () => {
    return {
      assessmentSchema,
      ready: false,
    };
  },
  mounted() {
    this.dataValue && (this.ready = true);
  },
  methods: {
    $_format(val) {
      if (!val) return;
      const charOne = val.charAt(0);

      return `${charOne.toUpperCase()}${val.substring(1)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.expected-impact-level {
  margin-top: 24px;
}

table {
  thead {
    background: rgba(0, 0, 0, 0.08);
    padding: 12px;
  }

  td,
  th {
    border: 1px solid lightgray !important;
    padding: 12px;

    p {
      margin: 6px 0px;
    }
  }
}

.flex {
  display: flex;
}

.content-text {
  padding: 1rem;
  margin: 0 0 1rem 0;
  border-radius: 6px;
}


.impact-level {
  padding: 0 5px !important;
  color: #2962ff;
}

.content-row {
  margin: 0 0 1rem 0;

  .content-title {
    font-weight: 600 !important;
  }
}
</style>
